export const ExpandingSearch = 'atlantis-expanding-search';